// Campus photo for /colleges/university-of-texas-at-dallas: Public domain, by Stan9999, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUT_Dallas_main_mall.JPG), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-texas-at-dallas/; credited under the photo.
const photo = {
    "slug": "university-of-texas-at-dallas",
    "alt": "A round reflecting pool under a white shade canopy, looking down the tree lined main mall at the University of Texas at Dallas in Richardson, Texas",
    "src": "/colleges/university-of-texas-at-dallas/campus-1600.webp",
    "srcSmall": "/colleges/university-of-texas-at-dallas/campus-800.webp",
    "srcMid": "/colleges/university-of-texas-at-dallas/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-texas-at-dallas/og.jpg",
    "title": "UT Dallas main mall",
    "author": "Stan9999",
    "license": "Public domain",
    "licenseUrl": null,
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUT_Dallas_main_mall.JPG",
    "read": "2026-10-01"
};

export default photo;
